import { render, staticRenderFns } from "./homeContent.vue?vue&type=template&id=a28cf85e&"
import script from "./homeContent.vue?vue&type=script&lang=js&"
export * from "./homeContent.vue?vue&type=script&lang=js&"
import style0 from "./homeContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports